import React from "react";
import styles from "./ButtonBack.module.scss";
import classNames from "classnames";

export type ButtonStatus =
  | "enabled"
  | "disabled"
  | "loading"
  | "done"
  | "alert";
export type ButtonSize = "medium" | "large";

export type ButtonBackProps = {
  /**
   * Состояние кнопки (влияет на внешний вид и возможность нажать ее).
   * По умолчанию: "enabled"
   */
  status?: ButtonStatus;
  /** Размер кнопки, по умолчанию medium */
  size?: ButtonSize;
  /** Тип */
  type?: "button" | "submit";
};

const ButtonBack: React.FC<
  ButtonBackProps & React.ComponentProps<"button">
> = ({
  title,
  status = "enabled",
  size = "medium",
  type = "button",
  ...restProps
}) => {
  return (
    <button
      type={type}
      className={classNames(styles.button, styles[size], styles[status])}
      disabled={status === "disabled"}
      {...restProps}
    />
  );
};

export default ButtonBack;
